<div class="team-leader-home">
  <div class="team-leader-home__content">
    <div class="team-leader-home__header">
      <div>
        <h1 class="page-title">Team Leaders</h1>
        <p class="page-subtitle">Manage team leaders and their partner assignments.</p>
      </div>
    </div>

    <app-table
      [data]="teamLeaderState.data()"
      [columns]="teamLeadersColumns"
      [config]="teamLeadersConfig"
      [pagination]="teamLeadersPagination"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onSearchChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"></app-table>
  </div>
</div>
